
import { ListItem, ListItemIcon, ListItemText, useTheme } from "@mui/material";
import { Square } from "@mui/icons-material";
import { ObjectNoSetpoint } from "./AdminSetpointListUtils";

export type ObjectListItemProps = {
    item: ObjectNoSetpoint,
};

export function ObjectListItem({
    item,
}: ObjectListItemProps) {


    const theme = useTheme();

    return (

        <ListItem disablePadding 
            sx={{
                paddingLeft: 1
            }} >
            <ListItemIcon sx={{fontSize: ".7rem", minWidth: 'auto', marginRight: theme.spacing(2)}}>
                <Square fontSize="inherit"/>
            </ListItemIcon>
            <ListItemText primary={item.displayText} />
    
        </ListItem>
    );
}
